const itensPagina = (items, page, pageSize) => {
  const startIndex = (page - 1) * pageSize;
  const endIndex = page * pageSize;
  return items.slice(startIndex, endIndex);
};

export default itensPagina;
